import React, {useState} from 'react';
import cx from 'classnames';
import './Button.scss';

function Button({onClick, id, dataTestId, label, buttonStyle, className, disabled = false, looksDisabled = false, leftIcon = null}) {
  const [isHover, setHover] = useState(false);
  const getLeftIcon = () => (leftIcon !== null || leftIcon !== undefined ? leftIcon(isHover) : <></>);

  return (
    <button
      data-testid={dataTestId}
      id={id}
      type='button'
      className={cx(
        {
          'prequal-ford-motion-button-primary': buttonStyle === 'primary',
          'prequal-ford-motion-button-tertiary': buttonStyle === 'tertiary',
          'prequal-ford-motion-button-secondary': buttonStyle !== 'primary' && buttonStyle !== 'tertiary',
          'prequal-ford-motion-button-primary-disabled': !disabled && looksDisabled
        },
        className
      )}
      onClick={(e) => onClick(e)}
      aria-disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      disabled={disabled}
    >
      <div className='prequal-ford-motion-button-content'>
        {buttonStyle === 'tertiary' && leftIcon != null && getLeftIcon()}
        <span>{label}</span>
      </div>
    </button>
  );
}

export default Button;
